export interface User {
  id: string;
  firstName: string;
  lastName: string;
  lastInitial?: string;
  nickname?: string;
  email: string;
  hashedPassword: string;
  role: UserRole;
  phone?: string;
  dob?: Date;
  eligibleForStudy?: boolean;
  loggedIn?: boolean;
  enrollmentConsent?: boolean;
  confirmedRegistration?: boolean;
  profileImageKey?: string;
  lastLogin?: Date;
  assessments?: any[];
  allAssessmentsCompleted?: boolean;
  assessmentsDaysLeft?: number;
  assessmentsLeft?: number;
  talentLmsUserId?: string;
  talentLmsUsername?: string;
  tlmsStartDate?: Date;
  tlmsChallengeCourseId?: string;
  tlmsNextChallengeCourseUnlockDate?: Date;
  brainHqUserId?: string;
  brainGaugeAccessCode?: string;
  organizationId: string;
  organization: {
    displayName: string;
    name: string;
    id: string;
    scoringPolicy?: string;
    bypassIrrCheck?: boolean;
  };
  forcedConsent?: boolean;
  currentCyclePillarScores?: any[];
  currentCycle?: any;
  lastCoachingSession?: any;
  nextCoachingSession?: any;
  cycleCompletionDate?: Date;
  aceCompleted?: boolean;
  ignoreData?: boolean;
  waitListed?: boolean;
  pardotId?: string;
  salesforceLeadId?: string;
  assessmentsReset: boolean;
  showNotificationPreferenceBanner: boolean;
  ianaTimeZoneName: string;
  currentSurveyId?: string;
  currentSurveyName?: string;
  badges?: any[];
  notifications?: Notification[];
  aceUserId?: string;
  totalHabitsCompleted: number;
  referralLink?: string;
  totalReferrals?: number;
  previousEmails?: any;
  requireResetPassword: boolean;
  consentForms?: any;
  active: boolean;
  dietidId: string;
  dietidAccessCode: string;
  showFirstVideoCallInfo: boolean;
  spouseLink?: string;
  spouseId?: string;
  firstTimeDashboard?: boolean;
  sumo?: any;
  acuityOauthToken?: string;
  tags?: any[];
}

export type UserRole = "admin" | "orgAdmin" | "participant" | "clinician" | "coach";

export interface RegisterFormValues {
  firstName: string;
  lastName: string;
  nickname?: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export interface LoginFormValues {
  email: string;
  password: string;
  loginFromAdmin: boolean;
}

export interface ForgotPasswordFormValues {
  email: string;
}

export interface ResetPasswordFormValues {
  newPassword: string;
  confirmPassword: string;
}

export enum UserCycleStatus {
  assessmentsNull = "assessments_null",
  assessmentsNotStarted = "assessments_not_started",
  assessmentsInProgress = "assessments_in_progress",
  readyToScore = "ready_to_score",
  scoringInProgress = "scoring_in_progress",
  readyForReview = "ready_for_review",
  scoreFinalized = "score_finalized"
}
